export const fetchVisitorToken = ({ CHAT_API, clientToken }) =>
  fetch(
    `${CHAT_API}/token?_client_token=${encodeURI(clientToken)}`,
    { headers: { Accept: 'application/json' }, credentials: 'include' }
  ).then((res) => res.json());

export const loadVisitorToken = async ({ CHAT_API, clientToken }) => {
  const responseAuthentication = await fetchVisitorToken({ CHAT_API, clientToken });
  const { _visitor_token } = responseAuthentication.data;
  return _visitor_token;
};
